import {useHistory, useParams} from "react-router-dom";
import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {
    getUtenteFromToken,
    PASSWORD_LENGTH,
    PASSWORD_LETTERS_DIGITS,
    PASSWORD_NO_FORBIDDEN_CHARS, PASSWORD_SPECIAL_CHARS
} from "../../utility/common";
import {attivaAccountApi} from "./services/AttivazioneAccountServices";
import AttivaAccountView from "./AttivaAccountView";
import FooterPassword from "../recupera_pwd/components/FooterPassword";
import {Divider} from "primereact/divider";

export default function AttivaAccountController() {
    const {token} = useParams()

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [passwordSel, setPasswordSel] = useState("");
    const [passwordCriteri, setPasswordCriteri] = useState({});
    const [passwordOk, setPasswordOk] = useState(false);
    const [password2Sel, setPassword2Sel] = useState("");
    const [password2Criteri, setPassword2Criteri] = useState({});
    const [password2Ok, setPassword2Ok] = useState(false);

    const {translate} = useContext(TranslateContext);
    const formikRef = useRef();

    const closeModal = () => setShow(false);

    const history = useHistory();

    function getCriteriPassword(password) {
        let lengthOk = password?.length >= 8;
        let lettersDigitsOk = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(password);
        let specialCharsOk = /[!#$%&'()*+,-.:;<=>@]/.test(password);
        let noForbinnedCharsOK = !password || /^[!-~]+$/.test(password);

        let ret = {};
        ret[PASSWORD_LENGTH] = lengthOk;
        ret[PASSWORD_LETTERS_DIGITS] = lettersDigitsOk;
        ret[PASSWORD_SPECIAL_CHARS] = specialCharsOk;
        ret[PASSWORD_NO_FORBIDDEN_CHARS] = noForbinnedCharsOK;
        return ret;
    }

    useEffect(() => {
        let criteri = getCriteriPassword(passwordSel);
        setPasswordCriteri(criteri);

        // la password è ok se tutti i criteri sono rispettati
        setPasswordOk(Object.values(criteri).every(b => b));
    }, [passwordSel])

    useEffect(() => {
        let criteri = getCriteriPassword(password2Sel);
        setPassword2Criteri(criteri);

        // la password è ok se tutti i criteri sono rispettati
        setPassword2Ok(Object.values(criteri).every(b => b));
    }, [password2Sel])

    async function attivaAccount(values) {
        if (values.password === values.password2) {
            let utente = getUtenteFromToken(token);
            if (utente && utente.id_utente && utente.id_utente !== '') {
                const usr = {
                    id_utente: utente.id_utente,
                    password: values.password,
                    password2: values.password2,
                };
                const response = await attivaAccountApi(usr, token);
                setModalMsg(response.data.description);
                setShow(true);
            } else {
                setModalMsg(translate('La Password e la Conferma password devono avere lo stesso valore'));
                setShow(true);
            }
        } else {
            setModalMsg(translate('La Password e la Conferma password devono avere lo stesso valore'));
            setShow(true);
        }
    }

    const formInitialValue = {
        password: '',
        password2: ''
    };

    function onClickGoToLogin() {
        history.push("/");
    }

    function getFooterPassword(criteriPassword) {
        return (
            <FooterPassword
                lengthOk={criteriPassword[PASSWORD_LENGTH]}
                lettersDigitsOk={criteriPassword[PASSWORD_LETTERS_DIGITS]}
                noForbinnedCharsOK={criteriPassword[PASSWORD_NO_FORBIDDEN_CHARS]}
                specialCharsOk={criteriPassword[PASSWORD_SPECIAL_CHARS]}
            />
        )
    }

    function getPasswordFooter() {
        return (
            <Fragment>
                <Divider/>
                {getFooterPassword(passwordCriteri)}
            </Fragment>
        );
    }

    function getConfirmPasswordFooter() {
        return (
            <Fragment>
                <Divider/>
                {getFooterPassword(password2Criteri)}
            </Fragment>
        );
    }

    function onChangePassword(event) {
        setPasswordSel(event.target.value);
    }

    function onChangeConfirmPassword(event) {
        setPassword2Sel(event.target.value);
    }

    return (
        <AttivaAccountView
            modalMsg={modalMsg}
            show={show}
            formikRef={formikRef}
            closeModal={closeModal}
            attivaAccount={attivaAccount}
            formInitialValue={formInitialValue}
            onClickGoToLogin={onClickGoToLogin}
            getPasswordFooter={getPasswordFooter}
            getConfirmPasswordFooter={getConfirmPasswordFooter}
            passwordOk={passwordOk}
            password2Ok={password2Ok}
            onChangePassword={onChangePassword}
            onChangeConfirmPassword={onChangeConfirmPassword}
        />
    )
}
